import React from 'react';
import { useSelector } from 'react-redux';
import { selectSuccessSnackbar } from './SnackbarSlice';
import { closeSuccessSnackbar } from './SnackbarActions';
import { Snackbar, Alert, AlertTitle } from '@mui/material';

export default function SuccessSnackbar() {
  const successSnackbar = useSelector(selectSuccessSnackbar);

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    closeSuccessSnackbar();
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={successSnackbar.open}
      autoHideDuration={10000}
      onClose={handleSuccessSnackbarClose}
    >
      <Alert
        onClose={handleSuccessSnackbarClose}
        severity='success'
        sx={{ width: '100%', textAlign: 'left' }}
        variant='filled'
      >
        <AlertTitle>Success</AlertTitle>
        {successSnackbar.message}
      </Alert>
    </Snackbar>
  );
}
